// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* NOTE: many of these constants have been duplicated in cssConstants.tsx */
/* Colours for Grid*/
/* Colours for Check statuses*/
/* Other colours */
/* black/grays/whites */
/* Colours for Data capture page*/
/* borders */
/* Dimensions*/
/* z-indexes */
/* Media queries */
/* Font Size */
/* Font Family */
/* Font Style */
/* Modifiers */
.phoneOnly {
  display: none;
}
@media (max-width: 599px) {
  .phoneOnly {
    display: block;
  }
  .notPhone {
    display: none;
  }
}
/* Buttons */
.iconButton {
  position: relative;
  border-width: 1px;
  border-style: solid;
  border-radius: 4px;
  background-color: transparent;
  color: #061c3f;
  border-color: #d8dde6;
  width: 32px;
  height: 32px;
  margin: 0;
  padding: 0;
  outline: none;
}
.iconButton img {
  width: 18px;
}
.iconButton img.chevronUpIcon {
  transform: rotate(180deg);
}
.iconButton.deleteIcon img {
  width: 16px;
}
.k-form > button,
.formStyledButton {
  color: #fff;
  background-color: #19419b;
}
.k-form > button.cancelButton,
.formStyledButton.cancelButton {
  background-color: #b7bbc0;
}
.error.longText .imgWrapper img {
  float: none;
}
.error.longText .errorBody {
  text-align: left;
}
/* Fields */
.k-form-field {
  color: #061c3f;
}
.k-form-field .label {
  color: #54698d;
}
.k-form-field > input,
.k-form-field > textarea {
  border-color: #a8b7c7;
  color: #54698d;
}
.k-form-field .k-input {
  color: #54698d;
}
.k-form-field .k-checkbox:checked + .k-checkbox-label::before {
  border-color: #0070d2;
  background-color: #0070d2;
}
.k-form-field .k-state-invalid > .k-picker-wrap,
.k-form-field .k-state-invalid > .k-dropdown-wrap,
.k-form-field .k-picker-wrap {
  border-color: #a8b7c7;
  color: #54698d;
}
.k-form-field .k-dropdown-wrap {
  border-color: #a8b7c7;
}
.k-form-field .k-datepicker .k-picker-wrap .k-dateinput-wrap {
  color: #54698d;
}
.prefixDropDownList.k-widget .k-dropdown-wrap {
  border-color: #d8dde6;
  color: #16325c;
}
.prefixDropDownList.k-widget .k-select .k-icon {
  color: #54698d;
}
.k-list-container .k-popup {
  color: #16325c;
}
.k-list-container .k-list-optionlabel {
  display: none;
}
.employmentSectorList.k-list-container .k-popup .k-list-scroller {
  max-height: 168px !important;
}
.bp3-portal {
  z-index: 101;
}
/* Misc */
.loadingPanel .highlightColor {
  color: #5ac790;
  border-color: #5ac790;
}
.loadingPanel.alternativePosition {
  top: 144px;
}
.toastContainer .toast {
  background: #262626;
}
button[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
.addressLookupField .autocompleteDropdownContainer {
  color: #54698d;
  border: 1px solid #a8b7c7;
  width: 288px;
}
@media (min-width: 786px) {
  .addressLookupField .autocompleteDropdownContainer {
    width: 626px;
  }
}
.k-animation-container {
  /* This is the dropdown list overlay that pops up. Its z-index has been set to make it appear in front of dialogs. */
  z-index: calc(10002 + 1);
  padding: 0px !important;
}
.k-animation-container .k-columnmenu-item.k-state-selected {
  background-color: #19419b;
}
.k-animation-container .k-filter-menu .k-primary {
  background-color: #19419b;
  border-color: #d8dde6;
}
.k-animation-container .k-filter-menu .k-primary:disabled {
  filter: brightness(1.2);
}
.k-animation-container .k-actions .k-primary {
  color: white;
  background-color: #19419b;
}
.k-animation-container .k-actions .k-primary:disabled {
  opacity: 1;
}
.k-animation-container .k-checkbox:checked {
  background-color: #1589ee;
  border-color: #1589ee;
  box-shadow: 0 0 0 2px rgba(21, 137, 238, 0.3);
}
.k-animation-container.shortPopup ul {
  /* This is used to shorten the height of the packages and checks popupsj so that it fits when used within the add
  	 checks and packages dialog. */
  height: 250px;
}
.k-calendar-container .k-calendar-navigation li:hover {
  color: #19419b;
}
.k-calendar-container .k-nav-today {
  color: #19419b;
}
.k-calendar-container .k-calendar-td.k-today {
  color: #19419b;
}
.k-calendar-container .k-calendar-td.k-state-selected .k-link {
  background-color: #19419b;
}
.saveToPdf {
  margin: 4px 0px !important;
}
html {
  height: 100%;
  font-size: 14px;
}
* {
  letter-spacing: 0.2px;
  box-sizing: border-box;
  -webkit-overflow-scrolling: touch;
}
body {
  height: 100%;
  font-weight: 400;
  font-family: 'sofia-pro', sans-serif;
  font-size: 14px;
  margin: 0;
  -webkit-print-color-adjust: exact !important;
  background-color: #fff;
}
#app {
  position: relative;
  min-height: 100%;
  overflow: hidden;
  margin: auto;
}
#app > #bodyContent {
  position: relative;
  /* This is to limit the loader's overlay. */
  margin-left: 80px;
  margin-top: 104px;
  margin-bottom: 52px;
  padding: 16px 40px 64px 40px;
  width: calc(100% - 80px);
}
#app > #bodyContent .pageTitle {
  position: fixed;
  top: 32px;
  left: 120px;
  right: 742px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #262626;
  font-size: 32px;
  font-weight: 600;
  margin: 0;
  padding: 0;
  z-index: 100;
}
@media (min-width: 600px) {
  #app > .globalHeader.withoutSearches ~ #bodyContent .pageTitle {
    right: 274px;
  }
  #app > .globalHeader.withoutControls ~ #bodyContent .pageTitle {
    right: 40px;
  }
}
.noBodyContentPadding #app > #bodyContent {
  padding-top: 0;
  padding-left: 0;
  padding-right: 0;
}
.noBodyContentPadding #app > #bodyContent .pageTitle {
  left: 120px;
}
.hasNotificationBanner #app > #bodyContent {
  margin-top: calc(104px + var(--notification-banner-height, 0px));
}
.hasNotificationBanner #app > #bodyContent .pageTitle {
  top: calc(32px + var(--notification-banner-height, 0px));
}
.k-dialog-titlebar {
  background-color: #262626;
  height: 45px;
}
.k-window :focus {
  outline: none !important;
}
.k-overlay {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2;
  cursor: default;
}
.bottomBorderDivider {
  border-bottom: 1px solid #dbdbdb;
}
.bottomBorderDivider td {
  border-bottom: 1px solid #dbdbdb;
}
.bottomBorderDivider:last-of-type {
  border-bottom: none;
}
.bottomBorderDivider:last-of-type td {
  border-bottom: none;
}
.topBorderDivider {
  border-top: 1px solid #dbdbdb;
}
.topBorderDivider td {
  border-top: 1px solid #dbdbdb;
}
.genericPageMessage {
  width: calc(100% - 80px);
}
.absoluteCentered {
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
}
.leftColumn,
.rightColumn {
  float: left;
  width: 50%;
}
.messageBox .error {
  vertical-align: middle;
}
.messageBox .message {
  color: #0d772d;
}
.messageBox strong {
  font-weight: 700;
}
a.anchorButton {
  font-weight: normal;
}
@media print {
  .pageBreak {
    page-break-before: always;
  }
}
.forcePrint .pageBreak {
  page-break-before: always;
}
span:focus,
input:focus,
textarea:focus,
button:focus {
  outline: 0;
}
@media (max-width: 899px) {
  #app > #bodyContent {
    padding: 14px 2% 92px 2%;
    min-height: 335px;
  }
}
@media (min-width: 631px) and (max-width: 1199px) {
  #app > #bodyContent .pageTitle {
    left: 106px;
  }
}
@media (min-width: 600px) and (max-width: 1180px) {
  #app > #bodyContent .pageTitle {
    right: 508px;
  }
}
@media (min-width: 600px) and (max-width: 630px) {
  #app > #bodyContent .pageTitle {
    left: 90px;
  }
}
@media (max-width: 599px) {
  #app > #bodyContent {
    margin-left: 0;
    margin-top: 0;
    padding: 0 16px 64px 16px;
    width: 100%;
  }
  #app > #bodyContent .pageTitle {
    color: #061c3f;
    position: relative;
    left: 0;
    top: 0;
    right: auto;
    white-space: normal;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    z-index: 97;
  }
  .hasNotificationBanner #app > #bodyContent {
    margin-top: var(--notification-banner-height, 0px);
  }
  .hasNotificationBanner #app > #bodyContent .pageTitle {
    top: 0;
  }
  .noBodyContentPadding #app > #bodyContent .pageTitle {
    left: 0;
  }
}
@media (max-width: 352px) {
  #app > #bodyContent {
    padding: 0 0 64px 0;
  }
}
/* Text */
h1 {
  font-size: 30px;
}
.error {
  color: #ff5151;
}
.bold {
  font-weight: bold;
}
.k-checkbox,
.k-radio {
  display: inline-block !important;
}
.k-checkbox:checked,
.k-checkbox:checked + .k-checkbox-label::before {
  background-color: #1589ee;
  border-color: #1589ee;
  box-shadow: 0 0 0 2px rgba(21, 137, 238, 0.3);
}
.k-radio:checked + .k-radio-label::before {
  background-color: transparent;
  border-color: #d8dde6;
}
.k-radio:checked:focus + .k-radio-label::before {
  box-shadow: none;
}
.k-radio:checked + .k-radio-label::after {
  background-color: #1589ee;
  box-shadow: none;
}
.k-grid-header .k-i-sort-asc-sm,
.k-grid-header .k-i-sort-desc-sm,
.k-grid-header .k-sort-order {
  color: #061c3f;
}
.k-pager-numbers-wrap .k-dropdown {
  display: none;
}
.k-pager-numbers .k-link {
  color: #061c3f;
}
.k-pager-numbers .k-state-selected {
  color: #fff;
  background-color: #061c3f;
}
.k-pager-nav:hover {
  color: #061c3f;
}
.k-pager-numbers .k-link:hover,
.k-pager-numbers .k-link.k-state-hover {
  color: #061c3f;
}
.k-grid {
  border-bottom: none;
  background-color: transparent;
  border-color: #f0f2f7;
  border-top: none;
  border-left: none;
  border-right: none;
}
.k-grid.withoutHeaderLinks .k-header .k-link {
  cursor: default;
}
.k-grid colgroup col {
  background-color: transparent;
}
.k-grid .k-grid-header {
  background-color: transparent;
  border-color: #f0f2f7;
  border-top: none;
  border-left: none;
  border-right: none;
}
.k-grid .k-grid-header tr.k-filter-row .k-icon {
  margin-top: 0;
}
.k-grid .k-grid-header tr .k-icon {
  margin-top: 9px;
}
.k-grid .k-grid-header tr .k-icon.k-i-more-vertical {
  margin-top: unset;
}
.k-grid .k-grid-header th {
  font-size: 24px;
  color: #061c3f;
  background-color: transparent;
  border-color: #f0f2f7;
  border-top: none;
  border-left: none;
  border-right: none;
}
.k-grid .k-grid-header .k-input {
  color: #061c3f;
}
.k-grid tbody tr:hover {
  background-color: #d5e0ea;
}
.k-grid tbody .k-alt {
  background-color: #f7f9fb;
}
.k-grid tbody td {
  border-left: none;
}
.k-grid tbody td:first-child {
  border-top-left-radius: 100px;
  border-bottom-left-radius: 100px;
}
.k-grid tbody td:last-child {
  border-top-right-radius: 100px;
  border-bottom-right-radius: 100px;
}
.k-form .k-dialog-wrapper .k-widget.k-dialog {
  display: flex;
}
.k-dialog-wrapper .k-window-content:last-child {
  padding-bottom: 0px !important;
}
.k-dialog-wrapper .k-window-content,
.k-dialog-wrapper .k-prompt-container {
  padding: 16px 16px 0 16px !important;
}
.k-dialog {
  margin-top: 104px;
  max-height: calc(100% - 104px - 20px);
  width: 920px;
  max-width: 95%;
}
.absoluteCentered .k-dialog.k-window {
  box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.3);
}
.k-dialog .treeWrapper {
  min-height: 250px !important;
}
.k-dialog .k-dialog-titlebar {
  background-color: #262626;
}
.k-dialog .k-dialog-titlebar .k-dialog-title,
.k-dialog .k-dialog-titlebar .k-icon {
  font-size: 16px;
}
.k-dialog .k-dialog-content .k-dialog-buttongroup {
  border: none;
}
.additionalNameLine .editIcon,
.addressHistoryLine .editIcon,
.additionalNameLine .deleteIcon,
.addressHistoryLine .deleteIcon {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  cursor: pointer;
}
.additionalNameLine .deleteIcon,
.addressHistoryLine .deleteIcon {
  right: 0;
}
.additionalNameLine .editIcon,
.addressHistoryLine .editIcon {
  right: 40px;
}
@media (min-width: 600px) {
  .k-dialog {
    max-width: calc(90% - 80px);
    left: 40px;
  }
}
@media (max-width: 599px) {
  .additionalNamesContainer .addButton.formStyledButton,
  .addressHistory .addButton.formStyledButton {
    float: none;
    display: block;
    margin: 20px auto 10px auto;
  }
  .k-dialog {
    margin-top: 40px;
    max-height: calc(100% - 40px - 20px);
  }
}
.k-multiselect .k-multiselect-wrap {
  height: 38px;
  padding-right: 48px;
}
.k-multiselect .k-multiselect-wrap .k-input,
.k-multiselect .k-multiselect-wrap .k-clear-value {
  height: calc(38px - 2px);
}
.k-list-container .k-popup .k-list-scroller {
  max-height: 168px !important;
}
.k-treeview-item,
.k-treeview .k-item {
  padding: unset !important;
  margin-left: -1px;
}
.k-textbox::selection,
.k-textbox .k-input::selection {
  color: #54698d;
  background: rgba(125, 188, 255, 0.6);
}
.cid-idp-selector-popup {
  padding-top: 135px !important;
}
`, "",{"version":3,"sources":["webpack://./src/appComponents/App.less","webpack://./src/appComponents/commonComponents.less"],"names":[],"mappings":"AAAA,2EAA2E;AAC3E,oBAAoB;AACpB,8BAA8B;AAC9B,kBAAkB;AAClB,uBAAuB;AACvB,iCAAiC;AACjC,YAAY;AACZ,cAAc;AACd,cAAc;AACd,kBAAkB;AAClB,cAAc;AACd,gBAAgB;AAChB,eAAe;AACf,cAAc;ACVd;EACC,aAAA;ADYD;ACTA;EACC;IACC,cAAA;EDWA;ECRD;IACC,aAAA;EDUA;AACF;AACA,YAAY;ACPZ;EACC,kBAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,6BAAA;EACA,cAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;ADSD;ACrBA;EAeE,WAAA;ADSF;ACPE;EACC,yBAAA;ADSH;ACLC;EACC,WAAA;ADOF;ACHA;;EAEC,WAAA;EACA,yBAAA;ADKD;ACJC;;EACC,yBAAA;ADOF;ACHA;EAEE,WAAA;ADIF;ACNA;EAME,gBAAA;ADGF;AACA,WAAW;ACCX;EACC,cAAA;ADCD;ACFA;EAIE,cAAA;ADCF;ACEC;;EAEC,qBAAA;EACA,cAAA;ADAF;ACVA;EAcE,cAAA;ADDF;ACbA;EAkBE,qBAAA;EACA,yBAAA;ADFF;ACjBA;;;EAyBE,qBAAA;EACA,cAAA;ADHF;ACvBA;EA8BE,qBAAA;ADJF;AC1BA;EAoCI,cAAA;ADPJ;ACaA;EAEE,qBAAA;EACA,cAAA;ADZF;ACSA;EAQG,cAAA;ADdH;ACmBA;EAEE,cAAA;ADlBF;ACgBA;EAQE,aAAA;ADrBF;ACyBA;EACC,4BAAA;ADvBD;AC2BA;EACC,YAAA;ADzBD;AACA,SAAS;AC4BT;EAEE,cAAA;EACA,qBAAA;AD3BF;AC8BC;EACC,UAAA;AD5BF;ACgCA;EAEE,mBAAA;AD/BF;ACmCA;EACC,YAAA;EACA,mBAAA;ADjCD;ACoCA;EAEE,cAAA;EACA,yBAAA;EACA,YAAA;ADnCF;ACuCA;EACC;IAEE,YAAA;EDtCD;AACF;AC2DA;EDzDE,oHAAoH;EC2DrH,wBAAA;EACA,uBAAA;ADzDD;ACsDA;EAKE,yBAAA;ADxDF;ACmDA;EASE,yBAAA;EACA,qBAAA;ADzDF;AC2DE;EACC,uBAAA;ADzDH;AC4CA;EAmBG,YAAA;EACA,yBAAA;AD5DH;AC8DG;EACC,UAAA;AD5DJ;ACqCA;EA6BE,yBAAA;EACA,qBAAA;EACA,6CAAA;AD/DF;ACmEA;EDjEE;iCAC+B;ECmEhC,aAAA;ADjED;ACoEA;EAEE,cAAA;ADnEF;ACiEA;EAME,cAAA;ADpEF;ACwEE;EACC,cAAA;ADtEH;ACyEE;EACC,yBAAA;ADvEH;AC4EA;EACC,0BAAA;AD1ED;AAtLA;EACC,YAAA;EACA,eAAA;AAwLD;AArLA;EACC,qBAAA;EACA,sBAAA;EAGA,iCAAA;AAqLD;AAlLA;EACC,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,eAAA;EACA,SAAA;EACA,4CAAA;EACA,sBAAA;AAoLD;AAjLA;EACC,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AAmLD;AAvLA;EAOE,kBAAA;EAmLA,2CAA2C;EAlL3C,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,4BAAA;EACA,wBAAA;AAoLF;AAhMA;EAeG,eAAA;EACA,SAAA;EAGA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;AAkLH;AA5KA;EAEC;IACC,YAAA;EA6KA;EAzKD;IACC,WAAA;EA2KA;AACF;AAxKA;EACC,cAAA;EACA,eAAA;EACA,gBAAA;AA0KD;AA7KA;EAME,WAAA;AA0KF;AAtKA;EACC,gEAAA;AAwKD;AAzKA;EAIE,wDAAA;AAwKF;AApKA;EACC,yBAAA;EACA,YAAA;AAsKD;AAnKA;EAEE,wBAAA;AAoKF;AAhKA;EACC,eAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,eAAA;AAkKD;AA/JA;EACC,gCAAA;AAiKD;AAlKA;EAIE,gCAAA;AAiKF;AA9JC;EACC,mBAAA;AAgKF;AAjKC;EAIE,mBAAA;AAgKH;AA3JA;EACC,6BAAA;AA6JD;AA9JA;EAIE,6BAAA;AA6JF;AAzJA;EACC,wBAAA;AA2JD;AAxJA;EACC,kBAAA;EACA,YAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;AA0JD;AAvJA;;EAEC,WAAA;EACA,UAAA;AAyJD;AAhJA;EAEE,sBAAA;AAiJF;AAnJA;EAME,cAAA;AAgJF;AAtJA;EAUE,gBAAA;AA+IF;AA3IA;EACC,mBAAA;AA6ID;AA1IA;EAvBC;IACC,yBAAA;EAoKA;AACF;AA3IA;EA1BE,yBAAA;AAwKF;AA1IA;;;;EAIC,UAAA;AA4ID;AAzIA;EACC;IACC,wBAAA;IACA,iBAAA;EA2IA;AACF;AAxIA;EACC;IAEE,WAAA;EAyID;AACF;AApIA;EACC;IAEE,YAAA;EAqID;AACF;AAjIA;EACC;IAEE,UAAA;EAkID;AACF;AA9HA;EACC;IACC,cAAA;IACA,aAAA;IACA,yBAAA;IACA,WAAA;EAgIA;EApID;IAOE,cAAA;IACA,kBAAA;IACA,OAAA;IACA,MAAA;IAEA,WAAA;IACA,mBAAA;IACA,eAAA;IACA,iBAAA;IACA,kBAAA;IACA,WAAA;EA+HD;EAzHD;IACC,kDAAA;EA2HA;EA5HD;IAIE,MAAA;EA2HD;EAvHD;IACC,OAAA;EAyHA;AACF;AAtHA;EACC;IACC,mBAAA;EAwHA;AACF;AACA,SAAS;AArHT;EACC,eAAA;AAuHD;AApHA;EACC,cAAA;AAsHD;AAnHA;EACC,iBAAA;AAqHD;AA1GA;;EAEC,gCAAA;AA4GD;AAzGA;;EAEC,yBAAA;EACA,qBAAA;EACA,6CAAA;AA2GD;AAxGA;EACC,6BAAA;EACA,qBAAA;AA0GD;AAvGA;EACC,gBAAA;AAyGD;AAtGA;EACC,yBAAA;EACA,gBAAA;AAwGD;AArGA;;;EAGC,cAAA;AAuGD;AApGA;EAEC,aAAA;AAqGD;AAlGA;EACC,cAAA;AAoGD;AAjGA;EACC,WAAA;EACA,yBAAA;AAmGD;AAhGA;EACC,cAAA;AAkGD;AA/FA;;EAEC,cAAA;AAiGD;AA9FA;EACC,mBAAA;EA/DA,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AAgKD;AAnGC;EACC,eAAA;AAqGF;AAzGA;EASG,6BAAA;AAmGH;AA5GA;EA9DC,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA6KD;AApGG;EAEE,aAAA;AAqGL;AAtHA;EAsBI,eAAA;AAmGJ;AAzHA;EA0BI,iBAAA;AAkGJ;AA5HA;EA+BG,eAAA;EACA,cAAA;EA9FF,6BAAA;EACA,qBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;AA+LD;AArIA;EAqCG,cAAA;AAmGH;AAxIA;EA6CG,yBAAA;AA8FH;AA3IA;EAiDG,yBAAA;AA6FH;AA9IA;EAqDG,iBAAA;AA4FH;AA1FG;EACC,6BAAA;EACA,gCAAA;AA4FJ;AAzFG;EACC,8BAAA;EACA,iCAAA;AA2FJ;AAnFA;EACC,aAAA;AAqFD;AAlFA;EAEE,8BAAA;AAmFF;AArFA;;EAME,oCAAA;AAmFF;AA/EA;EACC,iBAAA;EACA,qCAAA;EACA,YAAA;EACA,cAAA;AAiFD;AAhFC;EACC,0CAAA;AAkFF;AAxFA;EAUE,4BAAA;AAiFF;AA3FA;EAcE,yBAAA;AAgFF;AA9FA;;EAkBG,eAAA;AAgFH;AAlGA;EAuBE,YAAA;AA8EF;AA1EA;;;;EAIE,kBAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,eAAA;AA4EF;AApFA;;EAYE,QAAA;AA4EF;AAxFA;;EAgBE,WAAA;AA4EF;AAxEA;EACC;IACC,2BAAA;IACA,UAAA;EA0EA;AACF;AAvEA;EACC;;IAGE,WAAA;IACA,cAAA;IACA,2BAAA;EAwED;EApED;IAEC,gBAAA;IACA,oCAAA;EAqEA;AACF;AAlEA;EACC,YAAA;EACA,mBAAA;AAoED;AAtEA;;EAME,wBAAA;AAoEF;AAhEA;EACC,4BAAA;AAkED;AA/DA;;EAEC,yBAAA;EACA,iBAAA;AAiED;AA9DA;;EAEC,cAAA;EACA,oCAAA;AAgED;AA7DA;EACC,6BAAA;AA+DD","sourcesContent":["@import './constants.less';\n@import './commonComponents.less';\n\nhtml {\n\theight: 100%;\n\tfont-size: 14px;\n}\n\n* {\n\tletter-spacing: 0.2px;\n\tbox-sizing: border-box;\n\t// https://stackoverflow.com/questions/37313872/vertical-scrolling-in-ios-not-smooth\n\t// https://developer.apple.com/library/archive/documentation/AppleApplications/Reference/SafariCSSRef/Articles/StandardCSSProperties.html#//apple_ref/css/property/-webkit-overflow-scrolling\n\t-webkit-overflow-scrolling: touch;\n}\n\nbody {\n\theight: 100%;\n\tfont-weight: 400;\n\tfont-family: @sofiaFont;\n\tfont-size: 14px;\n\tmargin: 0;\n\t-webkit-print-color-adjust: exact !important;\n\tbackground-color: #fff;\n}\n\n#app {\n\tposition: relative;\n\tmin-height: 100%;\n\toverflow: hidden;\n\tmargin: auto;\n\n\t> #bodyContent {\n\t\tposition: relative; /* This is to limit the loader's overlay. */\n\t\tmargin-left: @navBarWidth;\n\t\tmargin-top: @globalHeaderHeight;\n\t\tmargin-bottom: @globalFooterHeight;\n\t\tpadding: 16px @layoutPadding 64px @layoutPadding;\n\t\twidth: calc(100% - @navBarWidth);\n\n\t\t.pageTitle {\n\t\t\tposition: fixed;\n\t\t\ttop: 32px;\n\t\t\t// The title sits in a different container to the header controls, so bounding its right edge\n\t\t\t// is what stops it running underneath them.\n\t\t\tleft: (@navBarWidth + @layoutPadding);\n\t\t\tright: @headerControlsWidth;\n\t\t\toverflow: hidden;\n\t\t\ttext-overflow: ellipsis;\n\t\t\twhite-space: nowrap;\n\t\t\tcolor: @backgroundColor;\n\t\t\tfont-size: 32px;\n\t\t\tfont-weight: 600;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0;\n\t\t\tz-index: @pageTitleZIndex;\n\t\t}\n\t}\n}\n\n// These classes outrank the width-based rules below, which cannot know which controls are rendered.\n@media (min-width: @tabletPortraitMinWidth) {\n\t// Only the customer selector is left on the management pages, so the title clears that alone.\n\t#app > .globalHeader.withoutSearches ~ #bodyContent .pageTitle {\n\t\tright: @headerControlsWidthForCustomerSelectorOnly;\n\t}\n\n\t// A data capture page renders no controls at all, so the title can use the full width.\n\t#app > .globalHeader.withoutControls ~ #bodyContent .pageTitle {\n\t\tright: @layoutPadding;\n\t}\n}\n\n.noBodyContentPadding #app > #bodyContent {\n\tpadding-top: 0;\n\tpadding-left: 0;\n\tpadding-right: 0;\n\n\t.pageTitle {\n\t\tleft: 120px;\n\t}\n}\n\n.hasNotificationBanner #app > #bodyContent {\n\tmargin-top: calc(@globalHeaderHeight + var(--notification-banner-height, 0px));\n\n\t.pageTitle {\n\t\ttop: calc(32px + var(--notification-banner-height, 0px));\n\t}\n}\n\n.k-dialog-titlebar {\n\tbackground-color: @labelGrey;\n\theight: 45px;\n}\n\n.k-window {\n\t:focus {\n\t\toutline: none !important;\n\t}\n}\n\n.k-overlay {\n\tposition: fixed;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\tz-index: @overlayZIndex;\n\tcursor: default;\n}\n\n.bottomBorderDivider {\n\tborder-bottom: 1px solid #dbdbdb;\n\n\ttd {\n\t\tborder-bottom: 1px solid #dbdbdb;\n\t}\n\n\t&:last-of-type {\n\t\tborder-bottom: none;\n\n\t\ttd {\n\t\t\tborder-bottom: none;\n\t\t}\n\t}\n}\n\n.topBorderDivider {\n\tborder-top: 1px solid #dbdbdb;\n\n\ttd {\n\t\tborder-top: 1px solid #dbdbdb;\n\t}\n}\n\n.genericPageMessage {\n\twidth: calc(100% - @navBarWidth);\n}\n\n.absoluteCentered {\n\tposition: absolute;\n\tmargin: auto;\n\tleft: 0;\n\tright: 0;\n\ttop: 0;\n\tbottom: 0;\n}\n\n.leftColumn,\n.rightColumn {\n\tfloat: left;\n\twidth: 50%;\n}\n\n.pageBreakMixin() {\n\t.pageBreak {\n\t\tpage-break-before: always;\n\t}\n}\n\n.messageBox {\n\t.error {\n\t\tvertical-align: middle;\n\t}\n\n\t.message {\n\t\tcolor: @statusGreen;\n\t}\n\n\tstrong {\n\t\tfont-weight: @sofiaFontBold;\n\t}\n}\n\na.anchorButton {\n\tfont-weight: normal;\n}\n\n@media print {\n\t.pageBreakMixin;\n}\n\n.forcePrint {\n\t.pageBreakMixin;\n}\n\nspan:focus,\ninput:focus,\ntextarea:focus,\nbutton:focus {\n\toutline: 0;\n}\n\n@media (max-width: @tabletPortraitMaxWidth) {\n\t#app > #bodyContent {\n\t\tpadding: 14px @mobileLayoutPadding (@layoutPadding + @globalFooterHeight) @mobileLayoutPadding;\n\t\tmin-height: 335px;\n\t}\n}\n\n@media (min-width: 631px) and (max-width: @mobileDeviceMaxWidth) {\n\t#app > #bodyContent {\n\t\t.pageTitle {\n\t\t\tleft: 106px;\n\t\t}\n\t}\n}\n\n// The referee search is hidden at this width, so the title can reclaim the space it occupied.\n@media (min-width: @tabletPortraitMinWidth) and (max-width: @refereeSearchHiddenMaxWidth) {\n\t#app > #bodyContent {\n\t\t.pageTitle {\n\t\t\tright: @headerControlsWidthWithoutRefereeSearch;\n\t\t}\n\t}\n}\n\n@media (min-width: @tabletPortraitMinWidth) and (max-width: 630px) {\n\t#app > #bodyContent {\n\t\t.pageTitle {\n\t\t\tleft: 90px;\n\t\t}\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t#app > #bodyContent {\n\t\tmargin-left: 0;\n\t\tmargin-top: 0;\n\t\tpadding: 0 16px 64px 16px;\n\t\twidth: 100%;\n\n\t\t.pageTitle {\n\t\t\tcolor: @nightBlue;\n\t\t\tposition: relative;\n\t\t\tleft: 0;\n\t\t\ttop: 0;\n\t\t\t// The header is hidden at this width, so the title no longer needs to avoid its controls.\n\t\t\tright: auto;\n\t\t\twhite-space: normal;\n\t\t\tfont-size: 30px;\n\t\t\tfont-weight: bold;\n\t\t\ttext-align: center;\n\t\t\tz-index: @pageTitleZIndexForMobile;\n\t\t}\n\t}\n\n\t// The header is hidden at this width, so the content only clears the banner itself and the title\n\t// stays in the normal flow rather than being pushed down by the banner a second time.\n\t.hasNotificationBanner #app > #bodyContent {\n\t\tmargin-top: var(--notification-banner-height, 0px);\n\n\t\t.pageTitle {\n\t\t\ttop: 0;\n\t\t}\n\t}\n\n\t.noBodyContentPadding #app > #bodyContent .pageTitle {\n\t\tleft: 0;\n\t}\n}\n\n@media (max-width: 352px) {\n\t#app > #bodyContent {\n\t\tpadding: 0 0 64px 0;\n\t}\n}\n\n/* Text */\nh1 {\n\tfont-size: 30px;\n}\n\n.error {\n\tcolor: @sunsetOrange;\n}\n\n.bold {\n\tfont-weight: bold;\n}\n\n.commonGridMixin() {\n\tbackground-color: transparent;\n\tborder-color: @greyF0;\n\tborder-top: none;\n\tborder-left: none;\n\tborder-right: none;\n}\n\n.k-checkbox,\n.k-radio {\n\tdisplay: inline-block !important;\n}\n\n.k-checkbox:checked,\n.k-checkbox:checked + .k-checkbox-label::before {\n\tbackground-color: @selectedBlue;\n\tborder-color: @selectedBlue;\n\tbox-shadow: 0 0 0 2px rgba(21, 137, 238, 0.3);\n}\n\n.k-radio:checked + .k-radio-label::before {\n\tbackground-color: transparent;\n\tborder-color: @paleGrey;\n}\n\n.k-radio:checked:focus + .k-radio-label::before {\n\tbox-shadow: none;\n}\n\n.k-radio:checked + .k-radio-label::after {\n\tbackground-color: @selectedBlue;\n\tbox-shadow: none;\n}\n\n.k-grid-header .k-i-sort-asc-sm,\n.k-grid-header .k-i-sort-desc-sm,\n.k-grid-header .k-sort-order {\n\tcolor: @nightBlue;\n}\n\n.k-pager-numbers-wrap .k-dropdown {\n\t// This shouldn't be necessary, likely an issue with using the older theme with the newer controls\n\tdisplay: none;\n}\n\n.k-pager-numbers .k-link {\n\tcolor: @nightBlue;\n}\n\n.k-pager-numbers .k-state-selected {\n\tcolor: #fff;\n\tbackground-color: @nightBlue;\n}\n\n.k-pager-nav:hover {\n\tcolor: @nightBlue;\n}\n\n.k-pager-numbers .k-link:hover,\n.k-pager-numbers .k-link.k-state-hover {\n\tcolor: @nightBlue;\n}\n\n.k-grid {\n\tborder-bottom: none;\n\n\t&.withoutHeaderLinks .k-header .k-link {\n\t\tcursor: default;\n\t}\n\n\tcolgroup {\n\t\tcol {\n\t\t\tbackground-color: transparent;\n\t\t}\n\t}\n\n\t.k-grid-header {\n\t\ttr {\n\t\t\t&.k-filter-row {\n\t\t\t\t.k-icon {\n\t\t\t\t\tmargin-top: 0;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.k-icon {\n\t\t\t\tmargin-top: 9px;\n\t\t\t}\n\n\t\t\t.k-icon.k-i-more-vertical {\n\t\t\t\tmargin-top: unset;\n\t\t\t}\n\t\t}\n\n\t\tth {\n\t\t\tfont-size: 24px;\n\t\t\tcolor: @nightBlue;\n\t\t\t.commonGridMixin();\n\t\t}\n\n\t\t.k-input {\n\t\t\tcolor: @nightBlue;\n\t\t}\n\n\t\t.commonGridMixin();\n\t}\n\n\ttbody {\n\t\ttr:hover {\n\t\t\tbackground-color: darken(@veryLightBlue, 10%);\n\t\t}\n\n\t\t.k-alt {\n\t\t\tbackground-color: @veryLightBlue;\n\t\t}\n\n\t\ttd {\n\t\t\tborder-left: none;\n\n\t\t\t&:first-child {\n\t\t\t\tborder-top-left-radius: 100px;\n\t\t\t\tborder-bottom-left-radius: 100px;\n\t\t\t}\n\n\t\t\t&:last-child {\n\t\t\t\tborder-top-right-radius: 100px;\n\t\t\t\tborder-bottom-right-radius: 100px;\n\t\t\t}\n\t\t}\n\t}\n\n\t.commonGridMixin();\n}\n\n.k-form .k-dialog-wrapper .k-widget.k-dialog {\n\tdisplay: flex; // To override Kendo default styling to fix no scroll issue on iPhone.\n}\n\n.k-dialog-wrapper {\n\t.k-window-content:last-child {\n\t\tpadding-bottom: 0px !important;\n\t}\n\t.k-window-content,\n\t.k-prompt-container {\n\t\tpadding: 16px 16px 0 16px !important;\n\t}\n}\n\n.k-dialog {\n\tmargin-top: @globalHeaderHeight;\n\tmax-height: calc(100% - @globalHeaderHeight - 20px);\n\twidth: 920px;\n\tmax-width: 95%;\n\t.absoluteCentered &.k-window {\n\t\tbox-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.3);\n\t}\n\n\t.treeWrapper {\n\t\tmin-height: 250px !important;\n\t}\n\n\t.k-dialog-titlebar {\n\t\tbackground-color: @backgroundColor;\n\n\t\t.k-dialog-title,\n\t\t.k-icon {\n\t\t\tfont-size: 16px;\n\t\t}\n\t}\n\n\t.k-dialog-content .k-dialog-buttongroup {\n\t\tborder: none;\n\t}\n}\n\n.additionalNameLine,\n.addressHistoryLine {\n\t.editIcon,\n\t.deleteIcon {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t\tbottom: 0;\n\t\tmargin: auto;\n\t\tcursor: pointer;\n\t}\n\n\t.deleteIcon {\n\t\tright: 0;\n\t}\n\n\t.editIcon {\n\t\tright: 40px;\n\t}\n}\n\n@media (min-width: @tabletPortraitMinWidth) {\n\t.k-dialog {\n\t\tmax-width: calc(90% - @navBarWidth);\n\t\tleft: (@navBarWidth / 2);\n\t}\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.additionalNamesContainer,\n\t.addressHistory {\n\t\t.addButton.formStyledButton {\n\t\t\tfloat: none;\n\t\t\tdisplay: block;\n\t\t\tmargin: 20px auto 10px auto;\n\t\t}\n\t}\n\n\t.k-dialog {\n\t\t@marginTop: 40px;\n\t\tmargin-top: @marginTop;\n\t\tmax-height: calc(100% - @marginTop - 20px);\n\t}\n}\n\n.k-multiselect .k-multiselect-wrap {\n\theight: @dataCaptureFormFieldHeight;\n\tpadding-right: 48px; // add 24px gap before the close X icon, so that user still can click on this gap to select more option if the selected option is too long.\n\n\t.k-input,\n\t.k-clear-value {\n\t\theight: calc(@dataCaptureFormFieldHeight - 2px); // Inner elements height should minus the outer border 2px.\n\t}\n}\n\n.k-list-container .k-popup .k-list-scroller {\n\tmax-height: 168px !important; // must add important to override kendo css\n}\n\n.k-treeview-item,\n.k-treeview .k-item {\n\tpadding: unset !important;\n\tmargin-left: -1px;\n}\n\n.k-textbox::selection,\n.k-textbox .k-input::selection {\n\tcolor: #54698d;\n\tbackground: rgba(125, 188, 255, 0.6);\n}\n\n.cid-idp-selector-popup {\n\tpadding-top: 135px !important;\n}\n","@import './constants.less';\n\n/* Modifiers */\n.phoneOnly {\n\tdisplay: none;\n}\n\n@media (max-width: @phoneOnlyMaxWidth) {\n\t.phoneOnly {\n\t\tdisplay: block;\n\t}\n\n\t.notPhone {\n\t\tdisplay: none;\n\t}\n}\n\n/* Buttons */\n.iconButton {\n\tposition: relative;\n\tborder-width: 1px;\n\tborder-style: solid;\n\tborder-radius: 4px;\n\tbackground-color: transparent;\n\tcolor: @nightBlue;\n\tborder-color: @paleGrey;\n\twidth: 32px;\n\theight: 32px;\n\tmargin: 0;\n\tpadding: 0;\n\toutline: none;\n\n\timg {\n\t\twidth: 18px;\n\n\t\t&.chevronUpIcon {\n\t\t\ttransform: rotate(180deg);\n\t\t}\n\t}\n\n\t&.deleteIcon img {\n\t\twidth: 16px;\n\t}\n}\n\n.k-form > button,\n.formStyledButton {\n\tcolor: @white;\n\tbackground-color: @buttonColor;\n\t&.cancelButton {\n\t\tbackground-color: @buttonGray;\n\t}\n}\n\n.error.longText {\n\t.imgWrapper img {\n\t\tfloat: none;\n\t}\n\n\t.errorBody {\n\t\ttext-align: left;\n\t}\n}\n\n/* Fields */\n.k-form-field {\n\tcolor: @nightBlue;\n\n\t.label {\n\t\tcolor: @metallicBlue;\n\t}\n\n\t& > input,\n\t& > textarea {\n\t\tborder-color: @blueyGrey;\n\t\tcolor: @metallicBlue;\n\t}\n\n\t.k-input {\n\t\tcolor: @metallicBlue;\n\t}\n\n\t.k-checkbox:checked + .k-checkbox-label::before {\n\t\tborder-color: @checkboxColor;\n\t\tbackground-color: @checkboxColor;\n\t}\n\n\t.k-state-invalid > .k-picker-wrap,\n\t.k-state-invalid > .k-dropdown-wrap,\n\t.k-picker-wrap {\n\t\tborder-color: @blueyGrey;\n\t\tcolor: @metallicBlue;\n\t}\n\n\t.k-dropdown-wrap {\n\t\tborder-color: @blueyGrey;\n\t}\n\n\t.k-datepicker {\n\t\t.k-picker-wrap {\n\t\t\t.k-dateinput-wrap {\n\t\t\t\tcolor: @metallicBlue;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.prefixDropDownList.k-widget {\n\t.k-dropdown-wrap {\n\t\tborder-color: @paleGrey;\n\t\tcolor: @darkSlateBlue;\n\t}\n\n\t.k-select {\n\t\t.k-icon {\n\t\t\tcolor: @metallicBlue;\n\t\t}\n\t}\n}\n\n.k-list-container {\n\t.k-popup {\n\t\tcolor: @darkSlateBlue;\n\t}\n\n\t// This is a solid orange bar that appears at the top of a list container - we shouldn't need it and it looks\n\t// unsightly.\n\t.k-list-optionlabel {\n\t\tdisplay: none;\n\t}\n}\n\n.employmentSectorList.k-list-container .k-popup .k-list-scroller {\n\tmax-height: 168px !important; // must add important to override kendo css\n}\n\n// Desktop date picker\n.bp3-portal {\n\tz-index: @datePickerZIndex;\n}\n\n/* Misc */\n.loadingPanel {\n\t.highlightColor {\n\t\tcolor: @highlightColor;\n\t\tborder-color: @highlightColor;\n\t}\n\n\t&.alternativePosition {\n\t\ttop: (@globalHeaderHeight + 40px);\n\t}\n}\n\n.toastContainer {\n\t.toast {\n\t\tbackground: @backgroundColor;\n\t}\n}\n\nbutton[disabled] {\n\topacity: 0.5;\n\tcursor: not-allowed;\n}\n\n.addressLookupField {\n\t.autocompleteDropdownContainer {\n\t\tcolor: @metallicBlue;\n\t\tborder: 1px solid @blueyGrey;\n\t\twidth: (@formFieldWidth - 30px);\n\t}\n}\n\n@media (min-width: @twoColumnFieldsPageMinWidth) {\n\t.addressLookupField {\n\t\t.autocompleteDropdownContainer {\n\t\t\twidth: ((@formFieldWidth * 2) - 10px);\n\t\t}\n\t}\n}\n\n.checkActionDefault() {\n\tbackground-color: rgba(25, 65, 155, 0.13);\n\tborder-radius: 50px;\n\theight: 32px;\n\tpadding: 8px 18px;\n\tmargin-right: 8px;\n\tmargin-bottom: 8px;\n\tcolor: @brightNavy;\n\tfont-size: 13px;\n\tfont-weight: @sofiaFontBold;\n\tdisplay: inline-block;\n\n\t.imageWrapper {\n\t\tmargin-right: 3px;\n\t}\n}\n\n.k-animation-container {\n\t/* This is the dropdown list overlay that pops up. Its z-index has been set to make it appear in front of dialogs. */\n\tz-index: calc(10002 + 1);\n\tpadding: 0px !important;\n\t.k-columnmenu-item.k-state-selected {\n\t\tbackground-color: @brightNavy;\n\t}\n\n\t.k-filter-menu .k-primary {\n\t\tbackground-color: @brightNavy;\n\t\tborder-color: @paleGrey;\n\n\t\t&:disabled {\n\t\t\tfilter: brightness(1.2);\n\t\t}\n\t}\n\n\t.k-actions {\n\t\t.k-primary {\n\t\t\tcolor: white;\n\t\t\tbackground-color: @linkBlue;\n\n\t\t\t&:disabled {\n\t\t\t\topacity: 1;\n\t\t\t}\n\t\t}\n\t}\n\n\t.k-checkbox:checked {\n\t\tbackground-color: @selectedBlue;\n\t\tborder-color: @selectedBlue;\n\t\tbox-shadow: 0 0 0 2px rgba(21, 137, 238, 0.3);\n\t}\n}\n\n.k-animation-container.shortPopup ul {\n\t/* This is used to shorten the height of the packages and checks popupsj so that it fits when used within the add\n  \t checks and packages dialog. */\n\theight: 250px;\n}\n\n.k-calendar-container {\n\t.k-calendar-navigation li:hover {\n\t\tcolor: @brightNavy;\n\t}\n\n\t.k-nav-today {\n\t\tcolor: @brightNavy;\n\t}\n\n\t.k-calendar-td {\n\t\t&.k-today {\n\t\t\tcolor: @brightNavy;\n\t\t}\n\n\t\t&.k-state-selected .k-link {\n\t\t\tbackground-color: @brightNavy;\n\t\t}\n\t}\n}\n\n.saveToPdf {\n\tmargin: 4px 0px !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
